export const USER_REPORT_REASONS = [
  { id: 'inappropriate', labelKey: 'report_reason_inappropriate' },
  { id: 'harassment', labelKey: 'report_reason_harassment' },
  { id: 'fraud', labelKey: 'report_reason_fraud' },
  { id: 'unsafe', labelKey: 'report_reason_unsafe' },
  { id: 'spam', labelKey: 'report_reason_spam' },
  { id: 'other', labelKey: 'report_reason_other' },
];

export function getOtherPartyFromBooking(booking, myRole) {
  if (!booking || !myRole) return null;
  if (myRole === 'customer' && booking.driver) {
    return {
      uid: booking.driver,
      name: (booking.driver_name || '').trim(),
      role: 'driver',
    };
  }
  if (myRole === 'driver' && booking.customer) {
    return {
      uid: booking.customer,
      name: (booking.customer_name || '').trim(),
      role: 'customer',
    };
  }
  return null;
}

/** Excluye socios bloqueados por el cliente al armar despacho local. */
export function filterDriversExcludingBlocks(drivers, blockedDriverIds = []) {
  if (!Array.isArray(drivers) || !blockedDriverIds?.length) return drivers || [];
  const blocked = new Set(blockedDriverIds);
  return drivers.filter((d) => d?.id && !blocked.has(d.id));
}

export function getBlockedDriverIdsFromMap(blockedMap) {
  if (!blockedMap || typeof blockedMap !== 'object') return [];
  return Object.keys(blockedMap);
}
